module.exports = new Promise((resolve) => {
                    var remoteUrl = '__REACT_APP_GENAI_URL__/genAIAssistantRemoteEntry.js?v=1791386973693';
                    var script = document.createElement('script');
                    script.src = remoteUrl;
                    script.onload = function() {
                        var proxy = {
                            get: function(request) { return window.GenAIAssistant.get(request); },
                            init: function(arg) {
                                try { return window.GenAIAssistant.init(arg); }
                                catch(e) { console.log('GenAIAssistant container already initialized'); }
                            }
                        };
                        resolve(proxy);
                    };
                    script.onerror = function() {
                        console.warn('GenAIAssistant remote entry failed to load from: ' + remoteUrl);
                        resolve({
                            get: function() { return Promise.resolve(function() { throw new Error('GenAIAssistant remote is unavailable'); }); },
                            init: function() {}
                        });
                    };
                    document.head.appendChild(script);
                });